<template>
  <div class="home">
    <!-- Shop by category section -->
    <div class="wrapper-content">
      <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
      <!-- breadcrumb -->
      <div class="breadcrumb_box">
        <div class="container-fluid">
          <h2>{{categoryName}}</h2>
          <p>
            <router-link to="/">{{ $t('message.Home') }}</router-link>
            /
            {{categoryName}}
          </p>
        </div>
      </div>
      <div class="container subcategoryContainer">
        <div class="row top-head">
          <div class="col-md-7"></div>
          <div class="col-md-5 searchBlockColumn">
            <div class="search">
              <input
                type="text"
                v-model="search"
                class="searchTerm"
                :placeholder="$t('message.Search') "
              />
              <button type="submit" class="searchButton" v-on:click="filteredList">
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 productListingCategoryArea" v-show="toggle">
            <div class="product-left panel">
              <div id="accordion">
                <div class="card categoryCard">
                  <div class="card-header" id="headingOne">
                    <h5 class="productLeftHeading">{{ $t('message.Categories') }}</h5>
                  </div>

                  <div
                    id="collapseOne"
                    class="collapse show"
                    aria-labelledby="headingOne"
                    data-parent="#accordion"
                  >
                    <div class="card-body">
                      <ul>
                        <li v-for="(category, index) in categoryItems" :key="index">
                          <div
                            class="pointer"
                            v-on:click="openSubcategories(category.id,category.meta.meta_slug)"
                          >{{category.name}}</div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-9 productListingArea">
            <div class="category_box subcat">
              <h4 v-if="filteredList==''" class="text-center mt-5">{{emptyMsg}}</h4>
              <ul id="subCategory" class="innerPageSubCat" v-else>
                <li v-for="(subCat, index) in filteredList" :key="index">
                  <div
                    v-on:click="viewPoducts(subCat.id,subCat.meta.meta_slug,subCat.name)"
                    class="pointer"
                  >
                    <img v-lazy="imageBaseUrl+ subCat.category_image" v-if="subCat.category_image" />
                    <img v-lazy="imageBaseUrl+ logoImg" v-else />
                    <h4>{{ subCat.name }}</h4>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HelloWorld from "@/components/HelloWorld.vue";
import cowMilk from "@/assets/images/cowmilk.jpg";
import buffaloMilk from "@/assets/images/buffalo-milk.jpg";
import soyaMilk from "@/assets/images/soyamilk.jpg";
import paneer from "@/assets/images/paneer.png";
import {
  getSubCategories,
  getMeta,
  getCategories,
  getDomainbaseVendorInfo,
  getSlugBaseInfo
} from "./../services/api";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-default.css";
import VueMeta from "vue-meta";
import VueLazyload from "vue-lazyload";

import Vue from "vue";
Vue.use(VueMeta);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  loading: "giphy.gif",
  attempt: 1
});
export default {
  components: {
    Loading
  },
  data() {
    return {
      toggle: true,
      descriptionMeta: "",
      titleMeta: "",
      keywordsMeta: "",
      isLoading: false,
      fullPage: true,
      categoryName: "",
      slide: 0,
      sliding: null,
      categoryItems: [],
      imageBaseUrl: "https://trakop.s3.amazonaws.com/",
      subCats: [],
      search: "",
      catId: localStorage.getItem("categoryId"),
      vendorId: "",
      catName: this.$route.params.subcategoryname,
      emptyMsg: "",
      logoImg: localStorage.getItem("logoImg")
    };
  },
  metaInfo() {
    return {
      meta: [
        {
          name: "description",
          content: this.descriptionMeta
        },
        {
          name: "title",
          content: this.titleMeta
        },
        {
          name: "keywords",
          content: this.keywordsMeta
        }
      ]
    };
  },

  created() {
    this.getItemsDetails();
    this.getCategoriesDetails();
  },
  computed: {
    filteredList() {
      return this.subCats.filter(post => {
        return post.name.toLowerCase().includes(this.search.toLowerCase());
      });
    }
  },
  methods: {
    openSubcategories(id, name) {
      localStorage.setItem("categoryId", id);

      this.$router.replace({
        name: "subcategory",
        params: { subcategoryname: name }
      });
      this.$router.go();
    },
    getCategoriesDetails() {
      if (!localStorage.getItem("token")) {
        var requestData = {
          user_type: "guest",
          vendor_id: localStorage.getItem("vendorId")
        };
      } else {
        var requestData = {
          user_id: localStorage.getItem("userId"),
          token: localStorage.getItem("token"),
          vendor_id: localStorage.getItem("vendorId")
        };
      }
      getCategories(requestData)
        .then(result => {
          if (result.data.successCode === 1) {
            this.categoryItems = result.data.allCategoryProductsList;
          } else if (
            result.data.successCode === 0 &&
            result.data.messageCode === 1053
          ) {
            localStorage.clear();
            this.$router.replace({ name: "register" });
          }
        })
        .catch(error => {
          return;
        });
    },
    getItemsDetails() {
      var requestData = {
        url: window.location.href,
        vendor_id: localStorage.getItem("vendorId")
      };

      this.isLoading = true;
      getSlugBaseInfo(requestData)
        .then(result => {
          // console.log("hfsdf", result);
          if (result.data.successCode === 1) {
            this.catId = result.data.allCategoryProductsList.category_id;
            this.subCats = result.data.allCategoryProductsList.sub_cat;
            if (this.subCats == "") {
              this.emptyMsg = "Sorry no products found..";
            }
            this.categoryName =
              result.data.allCategoryProductsList.categoryName;
            localStorage.setItem("categoryName", this.categoryName);
            this.getCategoryMeta();
            this.isLoading = false;
            return false;
          } else if (result.data.successCode === 0) {
            this.emptyMsg = "Sorry no products found..";
            this.isLoading = false;
          }
          if (result.data.messageText == "Record Not Found") {
            this.isLoading = false;
            this.$router.replace({ name: "404page" });
            return false;
          }
        })
        .catch(error => {
          return;
        });
    },
    viewPoducts(id, name, subcat) {
      localStorage.setItem("subcategoryName", subcat);
      localStorage.setItem("subcategoryId", id);

      this.$router.push({
        name: "product",
        params: { name: name, categoryname: this.catName.toLowerCase() }
      });
    },
    getCategoryMeta() {
      if (!localStorage.getItem("token")) {
        var requestData = {
          user_type: "guest",
          vendor_id: localStorage.getItem("vendorId"),
          type: "category",
          meta_id: this.catId
        };
      } else {
        var requestData = {
          user_id: localStorage.getItem("userId"),
          token: localStorage.getItem("token"),
          vendor_id: localStorage.getItem("vendorId"),
          type: "category",
          meta_id: this.catId
        };
      }
      getMeta(requestData)
        .then(result => {
          // console.log(result);
          if (result.data.successCode === 1) {
            this.titleMeta = result.data.data.meta_title;
            this.descriptionMeta = result.data.data.meta_description;
            this.keywordsMeta = result.data.data.meta_keywords;
          } else if (
            result.data.successCode === 0 &&
            result.data.messageCode === 1053
          ) {
            localStorage.clear();
            this.$router.replace({ name: "register" });
          }
        })
        .catch(error => {
          this.isLoading = false;
          return;
        });
    },

    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    }
  }
};
</script>